import React from 'react';
//import ReactDOM from 'react-dom';
import { createRoot } from "react-dom/client";
//import './index.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';


//--- bootstrap full 
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
//---------------

import 'font-awesome/css/font-awesome.min.css';
import 'react-notifications/lib/notifications.css';

import './css/AdminLTE2/css/AdminLTE.css';
import './css/AdminLTE2/css/skins/_all-skins.css';

//import './css/lte2.css';
import './css/bootstrapnubox.css';
import './css/tabla_edit.css';
import './css/tabla_cafe.css';
import './css/tabla_celeste.css';
//import './css/toolbar_estilo.css';
import './assets/css/tabla_basic.css';
import './css/tabla_fixed.css';
import './css/tabla_plomo.css';
import './css/tabla_azul.css';
import './css/adminpla.css';

import './css/sidebarEst.css';
//-- toast
import "react-toastify/dist/ReactToastify.css";

// browser router
import {BrowserRouter} from 'react-router-dom';

//----uso de REDUX---
//import { Provider } from 'react-redux';
//import store from './store';

//---- uso de CONTEXT API 
import StoreProvider from './store/StoreProvider'; 

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StoreProvider >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StoreProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
